import React from 'react';
import { CheckIcon, GiftIcon } from 'lucide-react';
import { bonuses } from '../data/site';
import { SectionCta } from './SectionCta';
export function BonusesSection() {
  return <section className="w-full overflow-hidden bg-sand px-3 py-14 sm:px-6 sm:py-20" data-id="element-62" data-mp="vsw8y0tmyjd2">
      <div className="mx-auto max-w-4xl" data-id="element-63" data-mp="vqjn3ckrbouq">
        <div className="text-center" data-id="element-64" data-mp="qsru0f8dlwoy">
          <p className="inline-flex items-center gap-1.5 rounded-full bg-navy px-3.5 py-1.5 text-[11px] font-bold uppercase tracking-[0.12em] text-gold-light" data-id="element-65" data-mp="qvw5zys31wq6">
            <GiftIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-66" data-mp="ztg9ledf453y" />
            Included today
          </p>
          <h2 className="mt-4 font-serif text-[28px] font-bold leading-[1.12] text-navy sm:text-4xl" data-id="element-67" data-mp="1ei2ml9fkoks0">
            And today, you’ll also get 5 premium bonuses
          </h2>
        </div>

        <div className="mt-10 space-y-8 sm:space-y-10" data-id="element-68" data-mp="1njahrimsl5hv">
          {bonuses.map(bonus => <article key={bonus.label} className="overflow-hidden rounded-2xl border border-navy/10 bg-white shadow-[0_18px_44px_-32px_rgba(12,21,38,0.4)]" data-id="element-69" data-mp="1jj9vxcxd5s0s">
              <div className="bg-cream" data-id="element-70" data-mp="3tr5fw1q885sf">
                <img src={bonus.image} alt={`${bonus.title} — ${bonus.hook}`} className="block w-full" width={1240} height={1240} data-id="element-71" data-mp="3ts6z4thebyl8" />
              </div>
              <div className="px-5 pb-6 pt-5 sm:px-7 sm:pb-7" data-id="element-72" data-mp="ckleelomwa81">
                <div className="flex flex-wrap items-center gap-2" data-id="element-73" data-mp="gldoti98sl5w">
                  <span className="rounded-full bg-navy px-3 py-1 text-[10.5px] font-bold uppercase tracking-[0.12em] text-gold-light" data-id="element-74" data-mp="gjkgzzmw7uwb">
                    {bonus.label}
                  </span>
                  <span className="rounded-full bg-emerald-50 px-3 py-1 text-[10.5px] font-bold uppercase tracking-[0.1em] text-emerald-800" data-id="element-75" data-mp="qaox52ob1lsq">
                    Included free
                  </span>
                </div>
                <h3 className="mt-3 font-serif text-[22px] font-bold leading-tight text-navy sm:text-[26px]" data-id="element-76" data-mp="10709fsnwabn6">
                  {bonus.title}
                </h3>
                <p className="mt-2 font-serif text-[16px] font-semibold italic text-gold" data-id="element-77" data-mp="5nguq3cbk99l">{bonus.hook}</p>
                <p className="mt-3 text-[14.5px] leading-relaxed text-navy/70" data-id="element-78" data-mp="kclevq2ocnkc">{bonus.description}</p>

                {bonus.items ? <ul className="mt-4 grid gap-x-5 gap-y-2 sm:grid-cols-2" data-id="element-79" data-mp="tbqd0vabqevz">
                    {bonus.items.map(item => <li key={item} className="flex items-start gap-2" data-id="element-80" data-mp="od5f52ijo7ap">
                        <CheckIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-gold" aria-hidden="true" data-id="element-81" data-mp="139wc754qx6x5" />
                        <span className="text-[14px] leading-snug text-navy/80" data-id="element-82" data-mp="yb2ybbljrdwg">{item}</span>
                      </li>)}
                  </ul> : null}

                <p className="mt-5 border-t border-navy/10 pt-4 text-[13px] font-bold uppercase tracking-[0.1em] text-navy/55" data-id="element-83" data-mp="3026ai5b350j4">
                  Reference value: <span className="text-navy line-through" data-id="element-84" data-mp="1fl6wogyooqan">{bonus.value}</span>{' '}
                  <span className="text-emerald-700" data-id="element-85" data-mp="1kji4km5f4qq8">Yours free today</span>
                </p>
              </div>
            </article>)}
        </div>

        <SectionCta headline="$147 in bonuses, included with your desk at no extra cost." label="Get the desk + 5 bonuses" data-id="element-86" data-mp="15shwwjchx0v5" />
      </div>
    </section>;
}